// src/utils/cryptoUtils.ts
import CryptoJS from 'crypto-js';

const SECRET_KEY =
  process.env.REACT_APP_BASE_SECRET || '1207446AOKjajsdmmiasdn121233';

export const encrypt = (text: string): string => {
  return CryptoJS.AES.encrypt(text, SECRET_KEY).toString();
};

export const decrypt = (ciphertext: string): string => {
  const bytes = CryptoJS.AES.decrypt(ciphertext, SECRET_KEY);
  return bytes.toString(CryptoJS.enc.Utf8);
};

export const saveWithExpiry = (
  key: string,
  value: string,
  ttl: number
): void => {
  const now = new Date();
  const item = {
    value: encrypt(value),
    expiry: now.getTime() + ttl,
  };
  localStorage.setItem(key, JSON.stringify(item));
};

export const getWithExpiry = (key: string): string | null => {
  const itemStr = localStorage.getItem(key);
  if (!itemStr) {
    return null;
  }
  const item = JSON.parse(itemStr);
  const now = new Date();
  if (now.getTime() > item.expiry) {
    localStorage.removeItem(key);
    return null;
  }
  return decrypt(item.value);
};
